import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase Web configuration is intentionally public. Firestore rules enforce access.
const firebaseConfig = {
  apiKey: 'AIzaSyBm3G-KtI7HY0LUvv32eD-j2mT609Sl9Dw',
  authDomain: 'loccoc-463d8.firebaseapp.com',
  projectId: 'loccoc-463d8',
  storageBucket: 'loccoc-463d8.firebasestorage.app',
  messagingSenderId: '762616437778',
  appId: '1:762616437778:web:cccc8e1ca4121f302dcccb',
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
